import React from 'react';

import { withTextSelection } from '../../../../hocs/withTextSelection';

import MarkdownPreviewWithAdditionalActions from '../../../../design-system/MarkdownPreviewWithAdditionalActions/MarkdownPreviewWithAdditionalActions';

const notFilledStateMessage = '*Not filled yet*';

const InfoContentPiece = ({ content, jobId, feedbackAllowed, logFeedbackTrigger }) => {
    const { value, is_filled, label } = content;

    return (
        <MarkdownPreviewWithAdditionalActions
            value={is_filled ? value : ''}
            label={label}
            withLogFeedbackButton={feedbackAllowed}
            logFeedbackTrigger={logFeedbackTrigger}
            threadId={jobId}
            placeholder={notFilledStateMessage}
        />
    );
};

const QuotableInfoContentPiece = withTextSelection(InfoContentPiece);

const FeedbackAwareInfoContentPiece = (props) => {
    const { feedbackAllowed } = props;

    if (feedbackAllowed) {
        return <QuotableInfoContentPiece {...props} />;
    }

    return <InfoContentPiece {...props} />;
};

export default FeedbackAwareInfoContentPiece;
